module.exports = __webpack_public_path__ + "static/ni-7c10d0c7beb319017c89e5d79889ece7.svg";